import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Lots_ModuleContextService } from './Lots.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Lots_lot_statuses_dd_ComponentContextService {
  private readonly moduleContext: Lots_ModuleContextService;

  constructor(moduleContext: Lots_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'lot_statuses_dd',
      type: ComponentType.selector
    }
  }
}